import { useEffect, useRef } from 'react';
import { logHomeNavBreadcrumb } from '../utils/homeNavigationDiagnostics';

export function useHomeNavDiagnostics({ cachedHome, homeContentReady }) {
  const firstPaintLoggedRef = useRef(false);
  const sectionsReadyLoggedRef = useRef(false);

  useEffect(() => {
    if (firstPaintLoggedRef.current) return;
    firstPaintLoggedRef.current = true;
    const raf = requestAnimationFrame(() => {
      logHomeNavBreadcrumb('first_paint', { from_cache: !!cachedHome });
    });
    return () => cancelAnimationFrame(raf);
  }, [cachedHome]);

  useEffect(() => {
    if (!homeContentReady || sectionsReadyLoggedRef.current) return;
    sectionsReadyLoggedRef.current = true;
    logHomeNavBreadcrumb('sections_ready', { from_cache: !!cachedHome });
  }, [homeContentReady, cachedHome]);
}
